import { atom } from "jotai";
import { addError } from "@zapier/observability";

import { ContentfulTemplate } from "../types";

export const contentfulTemplatesAsyncAtom = atom(async () => {
  try {
    const response = await fetch("/api/canvasui/templates");
    if (!response.ok) {
      throw new Error(`Error fetching templates: ${response.statusText}`);
    }
    const templates: ContentfulTemplate[] = await response.json();
    return templates;
  } catch (error) {
    addError(error, {
      source: "contentfulTemplatesAsyncAtom",
      context: {
        name: "template_fetch_error",
      },
    });
    return [];
  }
});

contentfulTemplatesAsyncAtom.debugLabel = "contentfulTemplatesAsyncAtom";
